import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../../styles/FindAccountPC.css';
import '../../../styles/PCResponsive.css';
import { findId, findPassword } from '../../../api';
import CommonTitle from '../../../components/common-title/CommonTitle';

function FindAccountPC() {
  const navigate = useNavigate();
  const [findIdForm, setFindIdForm] = useState({
    customerName: '',
    email: ''
  });

  const [findPasswordForm, setFindPasswordForm] = useState({
    id: '',
    customerName: '',
    email: ''
  });

  const [findIdLoading, setFindIdLoading] = useState(false);
  const [findPasswordLoading, setFindPasswordLoading] = useState(false);
  const [findIdError, setFindIdError] = useState('');
  const [findPasswordError, setFindPasswordError] = useState('');
  const [findPasswordResult, setFindPasswordResult] = useState('');

  const handleFindIdSubmit = async (e) => {
    e.preventDefault();
    // Field-specific alerts
    if (!findIdForm.customerName.trim()) {
      alert('고객명을 입력하세요');
      return;
    }
    if (!findIdForm.email.trim()) {
      alert('이메일을 입력하세요');
      return;
    }

    setFindIdLoading(true);
    setFindIdError('');
    
    try {
      const res = await findId(findIdForm.customerName.trim(), findIdForm.email.trim());
      const data = res?.data;
      
      let foundId =
        (typeof data === 'string' ? data : null) ||
        data?.id ||
        data?.userId ||
        data?.nickname ||
        data?.username ||
        data?.result?.id ||
        data?.result;

      if (!foundId || typeof foundId !== 'string') {
        throw new Error('일치하는 회원 정보를 찾을 수 없습니다.');
      }

      setFindIdLoading(false);
      navigate('/find-id-result', { state: { foundId } });
    } catch (err) {
      if (err?.response?.status === 404) {
        alert('존재하지 않습니다');
      } else {
        setFindIdError(
          err?.response?.data?.message ||
          err?.message ||
          '일치하는 회원 정보를 찾을 수 없습니다.'
        );
      }
      setFindIdLoading(false);
    }
  };

  const handleFindPasswordSubmit = async (e) => {
    e.preventDefault();
    if (!findPasswordForm.id || !findPasswordForm.customerName || !findPasswordForm.email) {
      alert("모든 필드를 입력해주세요.");
      return;
    }
    
    setFindPasswordLoading(true);
    setFindPasswordError('');
    setFindPasswordResult('');
    
    try {
      const res = await findPassword(findPasswordForm.id.trim(), findPasswordForm.customerName.trim(), findPasswordForm.email.trim());
      const data = res?.data;
      
      // Extract user ID from the API response message
      let extractedUserId = findPasswordForm.id; // fallback to input
      
      if (typeof data === 'string' && data.includes('id(') && data.includes(')')) {
        // Extract ID from message like "User validated. Proceed with password reset for id(dynamic_data)"
        const idMatch = data.match(/id\(([^)]+)\)/);
        if (idMatch && idMatch[1]) {
          extractedUserId = idMatch[1];
        }
      } else if (data?.id || data?.userId || data?.result?.id) {
        // Try other common response formats
        extractedUserId = data.id || data.userId || data.result.id;
      }
      
      // Update the form to show the extracted user ID (trimmed)
      setFindPasswordForm(prev => ({
        ...prev,
        id: extractedUserId.trim()
      }));
      
      
      // Show alert popup before navigation
      alert("비밀번호 분실 시 고객센터 1599-9442로 문의해 주시기 바랍니다.");
      setFindPasswordLoading(false);

      // Navigate to password reset page with the extracted user ID
      navigate('/find-account');
    } catch (error) {
      alert("존재하지 않습니다");
      setFindPasswordLoading(false);
      
    } finally {
      setFindPasswordLoading(false);
    }
  };

  const handleInputChange = (formType, field, value) => {
    if (formType === 'id') {
      setFindIdForm(prev => ({ ...prev, [field]: value }));
    } else {
      setFindPasswordForm(prev => ({ ...prev, [field]: value }));
    }
  };

  return (
    <div className="pc-page-container">
      <div className="pc-content-wrapper">
        
        
        {/* Main Content */}
        <main style={{backgroundColor: '#fff'}} className="pc-main-content">
          <div className="pc-content-container">
            {/* Title Section */}
            <div style={{marginTop: '-48px'}}>
           <CommonTitle heading="아이디/비밀번호 찾기" />
           </div>

            {/* Two Boxes Container */}
            <div style={{
              display: 'flex',
              gap: '40px',
              width: '100%',
              justifyContent: 'center'
            }}>
              {/* Left Box - 아이디 찾기 */}
              <div style={{
                flex: '0 1 500px',
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '40px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minWidth: 0
              }}>
                <h2 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#222222',
                  margin: '0 0 10px 0'
                }}>아이디 찾기</h2>
                <p style={{
                  fontSize: '14px',
                  color: '#666666',
                  margin: '0 0 25px 0',
                  lineHeight: '1.4'
                }}>등록된 회원정보로 아이디를 찾으실 수 있습니다.</p>
                
                <form onSubmit={handleFindIdSubmit}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    marginBottom: '25px'
                  }}>
                    <input
                      type="text"
                      placeholder="고객명"
                      value={findIdForm.customerName}
                      onChange={(e) => handleInputChange('id', 'customerName', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 15px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '6px',
                        fontSize: '14px',
                        backgroundColor: '#ffffff'
                      }}
                    />
                    <input
                      type="email"
                      placeholder="이메일"
                      value={findIdForm.email}
                      onChange={(e) => handleInputChange('id', 'email', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 15px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '6px',
                        fontSize: '14px',
                        backgroundColor: '#ffffff'
                      }}
                    />
                  </div>
                  {/* Inline error removed for Find ID per requirement; alerts are used instead */}
                  <button
                    type="submit"
                    disabled={findIdLoading}
                    style={{
                      width: '100%',
                      padding: '12px',
                      backgroundColor: findIdLoading ? '#cccccc' : '#2fb5a8',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: findIdLoading ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {findIdLoading ? '찾는 중...' : '아이디 찾기'}
                  </button>
                </form>
              </div>

              {/* Right Box - 비밀번호 찾기 */}
              <div style={{
                flex: '0 1 500px',
                backgroundColor: '#ffffff',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '40px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minWidth: 0
              }}>
                <h2 style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#222222',
                  margin: '0 0 10px 0'
                }}>비밀번호 찾기</h2>
                <p style={{
                  fontSize: '14px',
                  color: '#666666',
                  margin: '0 0 25px 0',
                  lineHeight: '1.4'
                }}>등록된 회원정보로 비밀번호를 찾으실 수 있습니다.</p>
                
                <form onSubmit={handleFindPasswordSubmit}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    marginBottom: '25px'
                  }}>
                    {/* First row - two fields side by side */}
                    <div style={{
                      display: 'flex',
                      gap: '15px'
                    }}>
                      <input
                        type="text"
                        placeholder="아이디"
                        value={findPasswordForm.id}
                        onChange={(e) => handleInputChange('password', 'id', e.target.value)}
                        style={{
                          flex: 1,
                          padding: '12px 15px',
                          border: '1px solid #e0e0e0',
                          borderRadius: '6px',
                          fontSize: '14px',
                          backgroundColor: '#ffffff'
                        }}
                      />
                      <input
                        type="text"
                        placeholder="고객명"
                        value={findPasswordForm.customerName}
                        onChange={(e) => handleInputChange('password', 'customerName', e.target.value)}
                        style={{
                          flex: 1,
                          padding: '12px 15px',
                          border: '1px solid #e0e0e0',
                          borderRadius: '6px',
                          fontSize: '14px',
                          backgroundColor: '#ffffff'
                        }}
                      />
                    </div>
                    {/* Second row - one full width field */}
                    <input
                      type="email"
                      placeholder="이메일"
                      value={findPasswordForm.email}
                      onChange={(e) => handleInputChange('password', 'email', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 15px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '6px',
                        fontSize: '14px',
                        backgroundColor: '#ffffff'
                      }}
                    />
                  </div>
                  {findPasswordError && (
                    <div style={{
                      color: '#e74c3c',
                      fontSize: '14px',
                      marginBottom: '15px',
                      textAlign: 'center'
                    }}>
                      {findPasswordError}
                    </div>
                  )}
                  {findPasswordResult && (
                    <div style={{
                      color: '#27ae60',
                      fontSize: '14px',
                      marginBottom: '15px',
                      textAlign: 'center'
                    }}>
                      {findPasswordResult}
                    </div>
                  )}
                  <button
                    type="submit"
                    disabled={findPasswordLoading}
                    style={{
                      width: '100%',
                      padding: '12px',
                      backgroundColor: findPasswordLoading ? '#cccccc' : '#666666',
                      color: '#ffffff',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '14px',
                      fontWeight: '600',
                      cursor: findPasswordLoading ? 'not-allowed' : 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {findPasswordLoading ? '찾는 중...' : '비밀번호 찾기'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </main>

        
      </div>
    </div>
  );
}

export default FindAccountPC; 